import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';

import { CircularProgress, Snackbar, Alert, TextField, MenuItem, Button, Checkbox, FormControlLabel, Grid, Typography, InputAdornment} from '@mui/material';
import { FolderOpen } from '@mui/icons-material';

import useErrorManager from "../../hooks/useErrorManager";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import { useBreadcrumb } from '../../contexts/BreadcrumbContext'; // Import breadcrumb context
import { useNotification } from '../../contexts/NotificationContext';


const StyledError = styled(Typography)`
  text-align: center;
  margin-top: 10px;
`;

function CreateLocation() {
    const [locationGroups, setLocationGroups] = useState([]);
    const [description, setDescription] = useState('');
    const [selectedGroup, setSelectedGroup] = useState('');
    const [name, setName] = useState('');
    const [isGroup, setIsGroup] = useState(false);

    const [loading, setLoading] = useState(true);

    const { setError, clearError, getError } = useErrorManager();
    const { showNotification } = useNotification();
    const { updateBreadcrumb } = useBreadcrumb();
    
    const navigate = useNavigate();
    const axiosInstance = useAxiosPrivate();  
    
    useEffect(() => {
        const fetchLocationGroups = async () => {
            try {
                const response = await axiosInstance.get('/locations/groups/list', {
                    withCredentials: true,
                });
                setLocationGroups(response.data);
                setSelectedGroup(response.data[0].id);
                clearError('fetch');
                setLoading(false);
            } catch (error) {
                setError('fetch', error.message);
                setLoading(false);
            }
        };
        
        updateBreadcrumb([
            { label: 'Manage Locations', link: '/locations'},
            { label: 'New Location'}
        ]);

        fetchLocationGroups();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                name,
                description,
                type: isGroup ? "Group" : "Location",
            };
            if (!isGroup) {
                payload.parentId = selectedGroup;
            }
            await axiosInstance.post('/locations/create', payload);
            setName('');
            setDescription('');
            setIsGroup(false);

            clearError('create');

            navigate(`/locations`, { state: { success: 'Location created successfully' }} )
        } catch (error) {
            setError('create', 'Error creating the location');
        }
    };

    const handleCheckboxChange = (e) => {
        setIsGroup(e.target.checked);
        if (e.target.checked) {
            setSelectedGroup('new');
        } else {
            setSelectedGroup('');
        }
    };


    return (
        loading ? (
                <CircularProgress />
            ) : (
                <>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            label={<span>Name</span>}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                            required
                            margin="normal"
                        />
                        <TextField
                            label={<span>Description</span>}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            fullWidth
                            required
                            margin="normal"
                        />


                        <Grid container alignItems="center" spacing={2}>
                            <Grid item xs={10}>
                                <TextField
                                    select
                                    label={<span>Location Group</span>}
                                    value={selectedGroup}
                                    onChange={(e) => setSelectedGroup(e.target.value)}
                                    fullWidth
                                    required
                                    margin="normal"
                                    // disabled={isGroup}
                                    disabled={true}
                                    InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <FolderOpen />
                                          </InputAdornment>
                                        ),
                                      }}
                                >
                                    {isGroup && (
                                        <MenuItem value="new">NEW LOCATION GROUP</MenuItem>
                                    )}
                                    {!isGroup && locationGroups.map((group) => (
                                        <MenuItem key={group.id} value={group.id}>
                                            {group.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isGroup}
                                            onChange={handleCheckboxChange}
                                            color="primary"
                                            disabled
                                        />
                                    }
                                    label="Group"
                                />
                            </Grid>
                        </Grid>

                        
                        <Button type="submit" variant="contained" color="primary" fullWidth>
                            Create Location
                        </Button>

                        {getError('create') && <StyledError variant="body2">{getError('create')}</StyledError>}



                    </form>
                </>        
            )
    );
}

export default CreateLocation;
